<!-- <div
  class="panel-menu cmn-panel-dsgn"
  [ngClass]="nextprevAnimation == 'Yes' ? 'animate__slideInUp' : nextprevAnimation == 'No' ? 'animate__slideInDown' : ''"
> -->
<div class="panel-menu cmn-panel-dsgn">
  <ng-container *ngFor="let panel of panels | queryListToArray; let i = index">
    <div
      class="panel-menu__option"
      *ngIf="!panel.hidden"
      (click)="selectPanel(i)"
      [ngClass]="{
        'panel-menu__option--active': (activePanelIndex$ | async | isEqualTo: i) && !!panel?.form,
        'panel-menu__option--valid': panel?.form?.valid && (activePanelIndex$ | async | notEqualTo: i),
        'panel-menu__option--invalid': panel?.form?.touched && panel?.form?.invalid && (activePanelIndex$ | async | notEqualTo: i)
      }"
    >
      <span>{{ panel.label }}<br />{{ panel.labelSecondary }}</span>
      <div class="statusContainer valid{{ panel?.form?.invalid }} touched{{ panel?.form?.touched }} pristine{{ panel?.form?.pristine }}">
        <div class="validStatus validStatus--invalid"></div>
        <div class="validStatus validStatus--notValidated"></div>
        <div class="validStatus validStatus--valid"></div>
      </div>
    </div>
  </ng-container>
</div>
<div class="panel-content" [ngClass]="isshow ? 'document_panel' : ' '">
  <ng-template [ngTemplateOutlet]="panels | panelTemplateRef: (activePanelIndex$ | async)"></ng-template>
</div>

<ng-content select="panel"></ng-content>
